import { render } from "./ContractFiguresScreen.vue?vue&type=template&id=48b191a8"
import script from "./ContractFiguresScreen.vue?vue&type=script&lang=js"
export * from "./ContractFiguresScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__